module.exports = __webpack_public_path__ + "static/img/major_pictgrid16_800x639.2a07ec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid16_800x639.jpg
// module id = p0N/
// module chunks = 0